import { Controller, useFormContext } from 'react-hook-form';
import type { TextFieldProps } from '@mui/material';

import { DEFAULT_DATE_FORMAT } from '@/shared/constants/date-formats.constants';

import type { DatePickerProps } from './DatePicker';
import { DatePicker } from './DatePicker';

export type RHFDatePickerProps = Omit<DatePickerProps<Date>, 'value' | 'onChange'> & {
  name: string;
  label?: string;
  format?: string;
  TextFieldProps?: Omit<TextFieldProps, 'onBlur'>;
};

export const RHFDatePicker = (props: RHFDatePickerProps) => {
  const { name, label, format = DEFAULT_DATE_FORMAT, TextFieldProps, ...datePickerProps } = props;
  const { placeholder = 'дд.мм.гггг', ...restOfTextFieldProps } = TextFieldProps ?? {};

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, ...restFieldProps }, fieldState: { error } }) => (
        <DatePicker
          {...restFieldProps}
          {...datePickerProps}
          format={format}
          slotProps={{
            textField: {
              ...restOfTextFieldProps,
              placeholder,
              label: label,
              error: !!error,
              helperText: error?.message ?? '',
              onBlur: onBlur,
            },
          }}
        />
      )}
    />
  );
};
